import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export interface RemoteAccessContext {
  adminUserId: string;
  personKey: number;
  iCodeFormatted?: string;
  /** True when the patient has no portal account (c_user row). UserKey-dependent endpoints will 401. */
  isNoAccount: boolean;
}

/**
 * Set when PatientMUI was opened by the admin portal via a remote access token.
 * Persisted to sessionStorage so the banner survives page reloads but is
 * automatically cleared when the tab is closed.
 */
export const remoteAccessContextAtom = atomWithStorage<RemoteAccessContext | null>(
  'remote_access_context',
  null,
  createJSONStorage(() => sessionStorage),
);
